<mat-card class="mat-elevation-z8">
  <form [formGroup]="vehicle_transport_register_from">
    <!-- user details -->
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>Transport Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <input type="text" class="form-control code_box" formControlName='name'>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>Contact Person <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <input type="text" class="form-control code_box" formControlName='contact_person'>
        </div>
      </div>
    </div>
    <div class="row">

      <div class="col">
        <div class="form-group">
          <label>Mobile <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <input type="text" class="form-control code_box" formControlName='mobile'>
          <div style="font-style: italic; font-size: small; color:red"
          *ngIf="vehicle_transport_register_from.controls.mobile.errors !== null">
          {{vehicle_transport_register_from.controls.mobile.errors['error']}}
        </div>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label>Altenate Mobile</label>
          <input type="text" class="form-control" formControlName='alternate_mobile'>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label> Address <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
      <textarea class="form-control" rows="3" formControlName='address'></textarea>
    </div>
  </form>
  <button style="margin-left: 40%;" mat-raised-button color="primary" [disabled]="!vehicle_transport_register_from.valid"
    (click)="registerVehicleTransport()">{{action}}</button>

</mat-card>
